export const optionsArea = {
    chart: {
        type: "area",
        height: 350,
        zoom: {
            enabled: false,
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: 'straight',
    },
    colors: [
        "rgba(127, 0, 255, 0.3)",
        "rgba(75, 192, 192, 0.6)",
    ],
}